import React, { useState, useEffect } from 'react';
import {Link, Navigate, useParams} from 'react-router-dom';
import Navbar from '../Components/Navbar/navbar.jsx';
import './editarcliente.css';
import firebase from '../Config/firebase';
import { collection, doc, getDoc, getFirestore, setDoc, query, orderBy, getDocs, deleteDoc } from 'firebase/firestore';
import SweetAlert from 'react-bootstrap-sweetalert';

function EditarProcesso(props){
    
    const [acao,setAcao] = useState('');
    const [processo,setProcesso] = useState('');
    const [data,setData] = useState('');
    const [valor,setValor] = useState('');
    const [situacao,setSituacao] = useState('');
    const [cpf,setCpf] = useState('');

    const [mensagem,setMensagem] = useState('');
    const [sucesso,setSucesso] = useState('N');
 
    const params = useParams();
    const db = getFirestore();

     useEffect(() =>{
          const fetchData = async () => {

          const docRef = doc(db, 'acoes', params.id);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
             setAcao(docSnap.data().acao);
             setProcesso(docSnap.data().processo);
             setData(docSnap.data().data);
             setValor(docSnap.data().valor);
             setSituacao(docSnap.data().situacao);
             setCpf(docSnap.data().cpf);
          } else {
            // docSnap.data() will be undefined in this case
            console.log("Não encontrado!");
          }
        }
        fetchData();
     }, [])

     function AlterarProcesso(){
        if (acao.length === 0){
            setMensagem('Informe o nome da ação');
        }
        else{
            const docRef = setDoc(doc(db, 'acoes', params.id),{
              acao: acao,
              processo: processo,
              data: data,
              valor: valor,
              situacao: situacao,
              cpf: cpf
              })
            .then((docRef) => {
              setMensagem('');
              setSucesso('S');
            })
            .catch((error) => {
              setMensagem(error);
              setSucesso('N');
            })
      }
      }

    return <div>
        <Navbar/>
        <div className="container-fluid titulo">
          <div className="offset-lg-1 col-lg-10">  
            <h1>Cadastro do Processo</h1>



            <form>

                    <label htmlFor="exampleInputEmail1" className="form-label ">Ação</label>
                    <input onChange={(e) => setAcao(e.target.value)} value={acao} type="text" className="form-control bg-dark-subtle w-100" id="exampleInputEmail1" aria-describedby="emailHelp"></input>
  
                    <label htmlFor="exampleInputEmail1" className="form-label pt-3">Processo</label>
                    <input onChange={(e) => setProcesso(e.target.value)} value={processo} type="text" className="form-control bg-secondary-subtle w-75" id="exampleInputEmail1" aria-describedby="emailHelp"></input>

                    <label htmlFor="exampleInputEmail1" className="form-label pt-3">Data</label>
                    <input onChange={(e) => setData(e.target.value)} value={data} type="text" className="form-control bg-secondary-subtle w-75" id="exampleInputEmail1" aria-describedby="emailHelp"></input>

                    <label htmlFor="exampleInputEmail1" className="form-label pt-3">Valor</label>
                    <input onChange={(e) => setValor(e.target.value)} value={valor} type="text" className="form-control bg-secondary-subtle w-75" id="exampleInputEmail1" aria-describedby="emailHelp"></input>

                    <label htmlFor="exampleInputEmail1" className="form-label pt-3">Situação</label>
                    <input onChange={(e) => setSituacao(e.target.value)} value={situacao} type="text" className="form-control bg-secondary-subtle w-75" id="exampleInputEmail1" aria-describedby="emailHelp"></input>
                    
                    <label htmlFor="exampleInputEmail1" className="form-label pt-3">CPF</label>
                    <input onChange={(e) => setSituacao(e.target.value)} value={cpf} type="text" className="form-control bg-secondary-subtle w-75" id="exampleInputEmail1" aria-describedby="emailHelp"></input>
                  
                  
                <div className = "text-center">
                  <Link to="/app/home" className="btn btn-outline-primary btn-mos1">Descartar Alterações</Link>
                  <button onClick={AlterarProcesso} type="button" className="btn btn-primary btn-mos2">Salvar</button>
                </div>
                {mensagem.length>0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}
                {sucesso==='S' ? <Navigate to='/app/home' /> : null}
            </form>
          </div>
        </div>  
    </div>
  }
  export default EditarProcesso;